import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { INVOICE_SYSTEM_SETTINGS_QUERY } from "./schema";

export const useInvoiceSystemSettingsQuery = (hotelID: string) => {
	const { data } = useCustomSuspenseQuery(INVOICE_SYSTEM_SETTINGS_QUERY, { variables: { hotelID } });

	return {
		data,
	};
};
